import React, { PropTypes } from 'react';

import trackingService from '../../../../state/services/tracking';

import ButtonLink from '../../../ButtonLink';

import { button, subtitle, title } from '../styles.module.css';

/**
 * Presentation component for Book Now without tickets.
 */
const NoTickets = ({ eventWebsite, titleLabel }) => (
  <div>
    <h2 className={title}>{titleLabel}</h2>
    {eventWebsite && (
      <div>
        <p className={subtitle}>{'View this event on the organiser’s website'}</p>
        <ButtonLink
          href={eventWebsite}
          className={button}
          onClick={() => trackingService.trackEvent('Website Clicked Out')}
          rel="noopener noreferrer nofollow"
          target="_blank"
        >
          {'View website'}
        </ButtonLink>
      </div>
    )}
    {!eventWebsite && <br />}
  </div>
);

NoTickets.propTypes = {
  eventWebsite: PropTypes.string,
  titleLabel: PropTypes.string.isRequired,
};

NoTickets.defaultProps = {
  eventWebsite: undefined,
};

export default NoTickets;



// WEBPACK FOOTER //
// ./app/src/components/EventHeader/BookNow/NoTickets/index.jsx